// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IApiGeoGetRoadsRequest,
  TApiGeoGetRoadsModel,
  IMappers,
  TApiGeoGetRoadsResponse,
  IApiGeoGetRoadsResponse,
} from './types';

export const defaultConfig: TApiGeoGetRoadsModel = {
  apiType: 'legacy',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'monolith-cian-realty',
  pathApi: '/api/geo/get-roads/',
} as TApiGeoGetRoadsModel;

export function createApiGeoGetRoadsModel(parameters: IApiGeoGetRoadsRequest): TApiGeoGetRoadsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IApiGeoGetRoadsOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IApiGeoGetRoadsRequest;
}

export async function fetchApiGeoGetRoads<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IApiGeoGetRoadsOptions<TResponse200>): Promise<TApiGeoGetRoadsResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createApiGeoGetRoadsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IApiGeoGetRoadsResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TApiGeoGetRoadsResponse;
}
